// 进度大于 10 ，进度百分比显示在内部；进度百分比小于 10 进度显示在外部
export const PLUMP_SEPARATE = 10;
